import { i18n, TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'
import { useEnvironment } from './useEnvironment'

type UseAppTranslationReturn = {
  t: TFunction
  i18n: i18n
  ready: boolean
}

type TranslationOptions = {
  keyPrefix?: string
}

export const useAppTranslation = (options?: TranslationOptions): UseAppTranslationReturn => {
  const { translationNamespace } = useEnvironment()
  return useTranslation(translationNamespace, options)
}
